import React from "react";
import FileDispatch from "./model";
import FileState from "../../State/FileState";
import { AppBar, Box, Button, Card, Chip, Dialog, Divider, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import { TransitionProps } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import AutoSizer from "react-virtualized-auto-sizer";
import Carousel from "react-material-ui-carousel";
import CircleIcon from '@mui/icons-material/Circle';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import MoshaveranUI from "../../../Moshaveran/UI/Mobile/Moshaveran";
import { removeBookmark, saveBookmark, saveSeen } from "../../../../../../../local/storage";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


class File extends React.PureComponent<{}>{

    render() {
        let dispatcher: FileDispatch = (this.props as any).dispatcher
        let state: FileState = (this.props as any).state

        if (state.data !== undefined)
            saveSeen(state.data)

        return (
            <Dialog
                fullScreen
                open={state.data !== undefined}
                dir="rtl"
                TransitionComponent={Transition} >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => {
                                dispatcher.close()
                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" component="div" sx={{ mr: 2, fontFamily: 'font-farsi-logo' }}>
                            ویـــلاگــــرام
                        </Typography>
                        <Typography variant="subtitle2" component="div" sx={{ flexGrow: 1, mr: 2 }} textAlign='start'>
                            : آگهی فیک نداریم
                        </Typography>
                        <Button size="small" variant="contained" startIcon={<BookmarkIcon sx={{ ml: 1 }} />} color={state.saved ? 'success' : "secondary"} onClick={() => {
                            if (state.saved) {
                                removeBookmark(state.data?.id ?? -1)
                            } else {
                                state.data && saveBookmark(state.data)
                            }

                            dispatcher.saved()
                        }}>
                            {state.saved ? 'ذخیره شده' : "ذخیره"}
                        </Button>

                    </Toolbar>
                </AppBar>

                <Box sx={{ width: '100%', height: '100%', flexDirection: 'column', overflow: 'auto' }} display='flex'>
                    <Box sx={{ width: '100%', flexDirection: 'column' }} display='flex'>

                        <Box sx={{ width: '100%', height: '400px', p: 0.5 }}>
                            <Card variant="outlined" sx={{ width: '100%', height: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5' }} >
                                <Box display="flex" sx={{ width: '100%', height: '100%' }}>
                                    <Card variant="elevation" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', m: 0.5, p: 0.2 }} >
                                        <Box sx={{ width: '100%', height: '100%' }} >
                                            <AutoSizer>
                                                {({ width, height }: any) => {
                                                    return (
                                                        <Carousel sx={{ width: width, height: height, direction: 'ltr' }} swipe={true} animation="slide" indicators={true} IndicatorIcon={<CircleIcon sx={{ width: '12px', height: '12px' }} />} // Previous Example
                                                            indicatorIconButtonProps={{
                                                                style: {
                                                                    padding: '3px',
                                                                    color: 'white'       // 3
                                                                }
                                                            }}
                                                            activeIndicatorIconButtonProps={{
                                                                style: {
                                                                    backgroundColor: 'black' // 2
                                                                }
                                                            }}
                                                            indicatorContainerProps={{
                                                                style: {
                                                                    marginTop: '-50px', // 5
                                                                    textAlign: 'center' // 4
                                                                    , position: 'absolute',
                                                                    zIndex: 1
                                                                }

                                                            }} navButtonsAlwaysVisible={true}>
                                                            {state.data?.pics.map((val, inx, arr) => {
                                                                return (
                                                                    <Box
                                                                        component="img"
                                                                        sx={{
                                                                            height: height,
                                                                            width: width,
                                                                            objectFit: 'contain'
                                                                        }}
                                                                        alt='vilage'
                                                                        src={state.data && state.data?.picPath + val}
                                                                        crossOrigin='anonymous'
                                                                    />

                                                                )
                                                            })}
                                                        </Carousel>

                                                    )
                                                }
                                                }
                                            </AutoSizer>
                                        </Box>
                                    </Card>
                                </Box>
                            </Card>
                        </Box>


                        <Box sx={{ width: '100%', p: 0.5 }}>
                            <Card variant="outlined" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5' }} >
                                <Box flexDirection='column' display="flex" sx={{ width: '100%' }}>

                                    <Card variant="elevation" sx={{ borderRadius: '24px', borderColor: 'transparent', m: 0.5, p: 0.2 }} >
                                        <Box sx={{ width: '100%', flexDirection: 'row', p: 0.5, flexWrap: 'wrap' }} display='flex'>


                                            {
                                                state.data?.props.map((val, index, arr) => {
                                                    return (
                                                        <Box key={val.value + val.title + index} sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                                            <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                                {val.title}
                                                            </Typography>
                                                            <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                                            <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                                {val.valueType === 'price' ? val.value.toWordPrice() : `${val.value}`}
                                                            </Typography>
                                                        </Box>
                                                    )
                                                })
                                            }
                                            <Box sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                    نوع
                                                </Typography>
                                                <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                    {(state.data?.fileType as any)?.title}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>

                                    {state.data?.description && <Box sx={{ width: '100%', p: 0.5 }}>
                                        <Card variant="outlined" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5' }} >
                                            <Box display="flex" sx={{ width: '100%' }}>
                                                <Card variant="elevation" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', m: 0.5, p: 0.2 }} >
                                                    <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }} >
                                                        <Typography variant="subtitle1" display="flex" sx={{ mr: 1, ml: 1 }} textAlign='right' dangerouslySetInnerHTML={{ __html: state.data?.description?.replaceAll('\n', '<br>') }} component="p">

                                                        </Typography>
                                                    </Box>

                                                </Card>
                                            </Box>

                                        </Card>

                                    </Box>}

                                    <Card variant="elevation" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', m: 0.5, flexGrow: 1 }} >
                                        <Box sx={{ width: '100%', flexDirection: 'row', p: 0.5, flexWrap: 'wrap', overflow: 'auto' }} display='flex'>
                                            {state.data?.tags.split(',').map((val, inx, arr) => {
                                                return <Chip key={val + inx} label={val} sx={{ m: 0.2 }} />
                                            })}
                                        </Box>
                                    </Card>

                                    <Box sx={{ width: '100%', p: 0.5 }}>
                                        <Card variant="outlined" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', bgcolor: '#f5f5f5' }} >
                                            <Box display="flex" sx={{ width: '100%' }}>
                                                <Card variant="elevation" sx={{ width: '100%', borderRadius: '24px', borderColor: 'transparent', m: 0.5, p: 0.2 }} >
                                                    <Box sx={{ width: '100%' }} >
                                                        <MoshaveranUI />
                                                    </Box>

                                                </Card>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Box>
                            </Card>
                        </Box>

                    </Box>
                </Box>
            </Dialog >
        )
    }

}

export default File

